// extracted by mini-css-extract-plugin
export default {"content":"delete-message_content__dO6Hy","tip":"delete-message_tip__aB2+l"};